<!-- 
 * @Descripttion: 
 * @Author: sjq
 * @Date: 2022-12-02 14:53:25
 * @LastEditors: sjq
 * @LastEditTime: 2024-02-26 09:17:47
 -->
<template>
  <div class="activation-page">
    <!-- 菜单栏（内嵌App时隐藏） -->
    <app-header :title="title" back-type="back-app" />

    <!-- 输入激活码 -->
    <div class="activation-form">
      <div class="activation-input">
        <input
          v-model="form.code"
          type="text"
          class="field-input_inner"
          :readonly="false"
          maxlength="50"
          @focus="placeholder = ''"
          @blur="placeholder = '请输入激活码'"
          :placeholder="placeholder"
        />
      </div>
      <div class="tips">
        <div class="tips-title">使用须知：</div>
        <ul class="tips-text">
          <li>1. 激活码可用以兑换友邻少年听课权益</li>
          <li>2. 请在有效期内使用激活码，激活码过期将无法使用</li>
        </ul>
      </div>
    </div>
    <div class="btn">
      <form-submit type="primary" size="small" text="激活" @submit="useActivation" />
    </div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
import Body from '@/mixins/body'
import { throttle } from '@/utils'
import { $couponCashed } from '@/utils/common/native-api'

const componentName = 'activation'
export default {
  name: componentName,
  componentName,
  data() {
    return {
      title: '激活码',
      form: { code: '' },
      placeholder: '请输入激活码'
    }
  },
  mixins: [Body],
  methods: {
    useActivation: throttle(
      function () {
        const data = this.form
        if (!data.code) {
          return Toast({ message: '请输入激活码', position: 'bottom' })
        }

        this.$store.dispatch('goods/activation/activationActive', data).then(res => {
          data.code = '' // 清除输入
          console.log(res, ';;;;aaa')
          $couponCashed()
          if (res && res.adviserName) {
            this.$router.push({
              name: 'activationAdviser'
            })
          } else {
            Toast({ message: '激活码使用成功！快去友邻少年APP学习吧', position: 'bottom' })
          }
        })
      },
      2000,
      { leading: true }
    )
  }
}
</script>

<style lang="scss">
.body-activation {
  background-color: #f3f5f7;
}
</style>
<style lang="less" scoped>
.activation-page {
  .activation-form {
    margin: 0.5rem 0.48rem;
    padding: 0.3rem;
    background-color: #fff;
    // 激活码输入
    .activation-input {
      border: 1px solid #eaeaea;
      border-radius: 0.1rem;
      padding: 0.3rem;
      line-height: 1.2;
      .field-input_inner {
        width: 100%;
        border-width: 0;
        color: #000000; // 输入的文本颜色
        outline: none;
        text-align: center;
        font-size: 0.48rem;
        -webkit-user-select: auto !important;
        caret-color: #888;
        &::-webkit-input-placeholder {
          color: #cccccc;
        }
      }
    }
    // 提示
    .tips {
      padding: 0.5rem 0.1rem;
      color: #888;
      .tips-title {
        padding: 0.2rem 0;
        margin-bottom: 0.1rem;
        font-size: 0.26rem;
        background-color: #fff;
      }
      ul.tips-text {
        font-size: 0.24rem;
        li {
          padding: 0.05rem 0;
          line-height: 0.36rem;
        }
      }
    }
  }
}
</style>
